import "./instrument";

import "./i18n";
import "./index.css";
import "sanitize.css";
import { LicenseInfo } from "@mui/x-license";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";

import App from "./App";
import { Theme } from "./Theme";
import { store } from "./services/store";

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_PRO_LICENSE_KEY);

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <ReduxProvider store={store}>
    <Theme />
    <App />
  </ReduxProvider>,
);
